import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaPhone } from 'react-icons/fa';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [expertiseOpen, setExpertiseOpen] = useState(false);
  const [collectionsOpen, setCollectionsOpen] = useState(false);
  const [hoverDisabled, setHoverDisabled] = useState(false);
  const location = useLocation();

  // Handle scroll effect for sticky header
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
    setExpertiseOpen(false);
    setCollectionsOpen(false);
  }, [location]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeDropdowns = () => {
    setExpertiseOpen(false);
    setCollectionsOpen(false);
    setHoverDisabled(true);
  };

  const enableHover = () => {
    setHoverDisabled(false);
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        {/* Logo */}
        <Link to="/" className="logo">
          <div className="logo-image">
            {/* <img src="../assets/images/f_h-logo-removebg-preview.png.png" alt="F&H Logo" /> */}
            <span className="logo-text">F&H</span>
          </div>
          <span className="logo-title">Audio Solutions LLP</span>
        </Link>

        {/* Desktop Navigation */}
        <nav className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
            Home
          </Link>
          <Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>
            About
          </Link>
          <div 
            className={`dropdown ${hoverDisabled ? 'hover-disabled' : ''}`}
            onMouseEnter={() => { enableHover(); setExpertiseOpen(true); }}
            onMouseLeave={() => setExpertiseOpen(false)}
          >
            <span 
              className={`dropdown-toggle ${location.pathname.startsWith('/services/') ? 'active' : ''}`} 
              onClick={() => setExpertiseOpen(!expertiseOpen)}
            >
              Our Expertise
            </span>
            <div className={`dropdown-menu ${expertiseOpen ? 'show' : ''}`} onClick={() => setExpertiseOpen(false)}>
              <Link to="/services/pa-system" onClick={closeDropdowns}>PA System Design & Installation</Link>
              <Link to="/services/acoustic-solutions" onClick={closeDropdowns}>Acoustic Solutions</Link>
              <Link to="/services/training-service" onClick={closeDropdowns}>Training & Service</Link>
            </div>
          </div>
          <div 
            className={`dropdown ${hoverDisabled ? 'hover-disabled' : ''}`}
            onMouseEnter={() => { enableHover(); setCollectionsOpen(true); }}
            onMouseLeave={() => setCollectionsOpen(false)}
          >
            <span 
              className={`dropdown-toggle ${location.pathname === '/products' || location.pathname === '/brands' ? 'active' : ''}`} 
              onClick={() => setCollectionsOpen(!collectionsOpen)}
            >
              Collections
            </span>
            <div className={`dropdown-menu ${collectionsOpen ? 'show' : ''}`} onClick={() => setCollectionsOpen(false)}>
              <Link to="/products" onClick={closeDropdowns}>Our Products</Link>
              <Link to="/brands" onClick={closeDropdowns}>Partner Brands</Link>
            </div>
          </div>
          <Link to="/consultancy" className={location.pathname === '/consultancy' ? 'active' : ''}>
            Consultation
          </Link>
          <Link to="/system-planner" className={location.pathname === '/system-planner' ? 'active' : ''}>
            System Planner
          </Link>
          <Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''}>
            Get in Touch
          </Link>
                    <Link to="/new-arrivals" className="nav-highlight">
            New Arrivals
          </Link>
        </nav>

        {/* CTA Button */}
        <a href="tel:+919876543210" className="cta-button">
          <FaPhone /> Book Now
        </a>

        {/* Mobile Menu Toggle */}
        <button className="menu-toggle" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
    </header>
  );
};

export default Header;
